// The weekday pickers' values, shared by the task editor and the create form so the two cannot offer the
// same day under different values.

// System.DayOfWeek's NAMES in ordinal order (Sunday = 0). The picker's values are the ordinals, which is
// what the save sends and the server accepts, but the API serialises a loaded trigger's day by name
// ("Wednesday"). A name left as it came matches no option, so the picker showed its placeholder instead of
// the day the task actually runs on.
export const WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

/** The days in the {value, label} shape FusionDropdown reads, valued by ordinal. A new array each call. */
export function weekdayDropdownOptions() {
  return WEEKDAY_NAMES.map((d, i) => ({ value: i, label: d }));
}

/** A day as the picker values it: an ordinal kept, a name (any case) or a digit string converted, else Monday. */
export function weekdayOrdinal(value) {
  if (typeof value === 'number') return value;
  if (/^\d$/.test(String(value))) return Number(value);
  const index = WEEKDAY_NAMES.findIndex(d => d.toLowerCase() === String(value).toLowerCase());
  return index >= 0 ? index : 1;
}
